export default __webpack_public_path__ + "static/media/employees.eb7ed7df.png";